import { render, staticRenderFns } from "./practicalAssessment.vue?vue&type=template&id=1591e296&scoped=true"
import script from "./practicalAssessment.vue?vue&type=script&lang=js"
export * from "./practicalAssessment.vue?vue&type=script&lang=js"
import style0 from "./practicalAssessment.vue?vue&type=style&index=0&id=1591e296&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1591e296",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1591e296')) {
      api.createRecord('1591e296', component.options)
    } else {
      api.reload('1591e296', component.options)
    }
    module.hot.accept("./practicalAssessment.vue?vue&type=template&id=1591e296&scoped=true", function () {
      api.rerender('1591e296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/practicalAssessment/practicalAssessment.vue"
export default component.exports